import React from "react";
import { Button } from "@sscs/ui";
import { PlaylistAddIcon as AddIcon } from "@sscs/ui/icons";
import { AllowedTo } from "Components";
import { PERMISSION } from "Constants";
import InviteMember from "../InviteMember/InviteMember";
import styles from "./membersTableActionBar.module.scss";

type ActionBarButtonProps = {
  openInviteMemberToOrg: () => void;
  closeInviteMemberToOrg: () => void;
  inviteMemberToOrgOpen: boolean;
};

const ActionBarButton = ({
  openInviteMemberToOrg,
  closeInviteMemberToOrg,
  inviteMemberToOrgOpen,
}: ActionBarButtonProps): React.JSX.Element => {
  return (
    <AllowedTo permissions={[PERMISSION.MODIFY_MEMBERS_ORGANIZATION_ROLE]}>
      <>
        <Button
          color="primary"
          className={styles["invite-member"]}
          onClick={openInviteMemberToOrg}
        >
          <AddIcon />
          Invite member
        </Button>
        <InviteMember
          isOpen={inviteMemberToOrgOpen}
          onClose={closeInviteMemberToOrg}
        />
      </>
    </AllowedTo>
  );
};

export default ActionBarButton;
